<template>
  <div class="telecontrol">
    <div class="top">
      <div style="height: 40px;line-height: 40px;display: flex;align-items: center;">
        <div style="width:10%;display: flex;align-items: center;justify-content: center;" @click="goBack">
          <van-icon name="arrow-left" color="#fff" size="25px"/>
        </div>
        <div :style="isRed ? fontRed: fontWhite" @click="showSend('app')"
             style="width:90%;display: flex;align-items: center;justify-content: center;">
          {{name}}
        </div>
      </div>
      <div class="top1">
        <div class="top1_btn topBtnL" hover-class="powerOn" @click="RemoteFunc('powenOn')"></div>
        <div class="top1_btn topBtnM">
          <div class="voiceBtn topBtnMLeft" hover-class="voice_down" @click="RemoteFunc('voiceDown')"></div>
          <div class="voiceBtn topBtnMRight" hover-class="voice_up" @click="RemoteFunc('voiceUp')"></div>
        </div>
        <div class="top1_btn topBtnR" hover-class="muteOn" @click="RemoteFunc('muteOn')"></div>
      </div>

      <div class="top2">
        <div class="top2_direction">
          <div class="top2_btn top2_up" hover-class="top2_up_hover" @click="RemoteFunc('up')"></div>
          <div class="top2_btn top2_left" hover-class="top2_left_hover" @click="RemoteFunc('left')"></div>
          <div class="top2_btn top2_middle" hover-class="top2_middle_hover" @click="RemoteFunc('middle')"></div>
          <div class="top2_btn top2_right" hover-class="top2_right_hover" @click="RemoteFunc('right')"></div>
          <div class="top2_btn top2_down" hover-class="top2_down_hover" @click="RemoteFunc('down')"></div>
        </div>
      </div>
      <div class="top3">
        <div class="top3_left" hover-class="top3_left_hover" @click="RemoteFunc('back')"></div>
        <div class="top3_right" hover-class="top3_right_hover" @click="RemoteFunc('menu')"></div>
      </div>
      <div class="top4">
        <div class="top4_left_wrap" @click="RemoteFunc('home')">
          <div class="top4_left" hover-class="top4_left_hover"></div>
        </div>
        <div class="top4_middle"></div>
        <div class="top4_right_wrap" @click="showSend('app')">
          <div class="top4_right" hover-class="top4_right_hover"></div>
        </div>
      </div>
    </div>


    <van-action-sheet
      v-model=" isVisible1"
      :round="isRound"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4" offset="0">
          <van-button
            style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -14px;"
            @click="closeGroup" color="#FF5700" size="small">{{$t('append_field.cancel')}}</van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">{{$t('append_field.deviceList')}}</van-col>
        <van-col :span="4" offset="0">
          <van-button
            style="width:100%;background:none;color:#006EFF;border:none;line-height:40px;height:40px;text-indent: -14px;"
            @click="confirmSend" color="#006EFF" size="small">{{$t('append_field.confirm')}}</van-button>
        </van-col>
      </van-row>
      <div style="" class="equirpGroupContent scroll">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse class="scroll-a" v-model="activeNames2" @change="onCollapseChange" accordion>
          <van-collapse-item v-for="(item,index) in menuItems2" :key="index" :name="index" :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <van-radio-group v-model="radio" v-if="index === activeNames2">
              <van-cell-group>
                <van-cell
                  v-for="(item2,index2) in data"
                  :key="index2"
                  :title="item2.name"
                  value-class="value-class"
                  :data-name="index2"
                  clickable
                  @click="toggle(item2)"
                  :icon="item2.onlineState == '1' ? 'static/images/icon_dev_online.png' : 'static/images/icon_dev_disonline.png'"
                >
                  <van-radio slot="right-icon" :name="item2.clId"/>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>


  </div>
</template>

<script>
  import qs from 'qs'
  import {Toast} from 'vant'

  export default {
    name: "telecontrol.vue",
    data() {
      return {
        orderNum: '',
        list: [],
        selectParent: false,
        name: this.$t('append_field.selectDevice'),
        delesId: "",
        clientNo: "",
        isRed: true,
        fontRed: 'color: red',
        fontWhite: 'color: #fff',

        isVisible1: false,
        menuItems2: [],
        isRound: false,
        activeNames2: '',
        chooseEquipArr: [],
        radio: '',
        sendTaskId: '',
        seletedEquip: {},
        dataList: [],
        doch: 0,
        data: [],
        index: 0,
      }
    },
    computed: {},
    mounted() {
      this.doch = window.screen.height

    },
    methods: {
      back() {
        this.$router.push({path: '/my'})
      },
      RemoteFunc: function (res) {
        if (this.name === "" || this.name === this.$t('append_field.selectDevice')) {
          let options = {
            message: this.$t('append_field.selectDevice'),
            duration: 2000,
            type: "danger"
          };
          Toast(options)
          return
        }


        if (res === 'powenOn') {
          this.orderNum = '7001'
        } else if (res === 'voiceDown') {
          this.orderNum = '7003'
        } else if (res === 'voiceUp') {
          this.orderNum = '7002'
        } else if (res === 'muteOn') {
          this.orderNum = '7011'
        } else if (res === 'up') {
          this.orderNum = '7004'
        } else if (res === 'left') {
          this.orderNum = '7006'
        } else if (res === 'middle') {
          this.orderNum = '7008'
        } else if (res === 'right') {
          this.orderNum = '7007'
        } else if (res === 'down') {
          this.orderNum = '7005'
        } else if (res === 'back') {
          this.orderNum = '7012'
        } else if (res === 'menu') {
          this.orderNum = '7009'
        } else if (res === 'home') {
          this.orderNum = '7010'
        } else if (res === 'app') {
          this.orderNum = ''
        }


        this.$ajax.post("/etv/appletsRemote.json", qs.stringify({
          instruction: this.orderNum,
          clientNo: this.seletedEquip.clNo,
          id: this.seletedEquip.clId

        })).then(res => {
          if (res.data.code === 0) {
            Toast({type: 'success', message: res.data.msg});
          } else {
            Toast({type: 'danger', message: res.data.msg});
          }
        })
      },
      showSend() {
        this.isVisible1 = true
        this.$ajax.post("/etv/selectSeachClientTreeMobile.json", {
          groupParentId: "",
          type: "",
          onlineState: "",
          clientName: ""
        }).then(res => {
          if (res.data.code === 0) {
            this.menuItems2 = res.data.data;
            // this.dataList = res.data.data;
          }
          const Terminal = document.getElementsByClassName('scroll')[0]

          Terminal.addEventListener('scroll', this.handleScroll)
        })
      },

      onCollapseChange(activeNames2) {
        this.index = 0
        if (activeNames2 === '') {
          return
        }
        this.activeNames2 = activeNames2
        if (this.menuItems2[this.activeNames2].children.length > 0) {
          this.data = this.menuItems2[this.activeNames2].children.slice(this.index, 15)
        } else {
          this.data = []
        }
      },

      toggle(r1) {

        this.radio = r1.clId
        this.seletedEquip = r1
      },
      closeGroup() {
        this.isVisible1 = false;
        this.menuItems2 = []
      },
      confirmSend() {
        if (this.radio == '') {
          Toast(this.$t('append_field.selectDevice'))
          return
        }

        this.name = this.seletedEquip.name
        this.isVisible1 = false
        this.isRed = false

      },
      goBack() {
        this.$router.push({path: '/my'})
      },
      handleScroll() {
        //滚动条
        const scrollHeight = document.getElementsByClassName('scroll')[0].scrollTop
        let clientHeight = document.getElementsByClassName('scroll-a')[0].clientHeight
        //真实高度
        if (clientHeight - this.doch - scrollHeight + 70 < 40) {
          if (this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
            return
          }
          this.index++
          this.data = [...this.data, ...this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15)]
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .telecontrol {
    height: 100% !important;
    position: fixed;
    left: 0;
    top: 0px;
    bottom: 0px;
    right: 0;
    background: #272727;
    z-index: 999;

    .van-collapse-item__content {
      padding: 0 16px;
    }

    .equirpGroupContent {
      height: 25rem;
      overflow-y: auto;
      width: 100%;

      .van-collapse-item__wrapper {
        position: relative;

        .van-cell {

          .van-checkbox {
            justify-content: flex-end;
          }
        }
      }

    }

    .top {
      position: fixed;
      left: 0;
      top: 0px;
      bottom: 0px;
      right: 0;
      display: flex;
      flex-direction: column;

      & > * {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .top1 {
        position: absolute;
        top: 60px;
        width: 100%;
        height: 54px;
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        align-items: center;
        /*padding: 0 20px;*/

        .topBtnL {
          width: 50px;
          height: 50px;
          background: url('/static/images/tv_turn_up.png') no-repeat;
          background-size: 100% 100%;

          &:active {
            background: url('/static/images/tv_turn_down.png') no-repeat;
            background-size: cover;
          }
        }

        .powerOn {
          background: url('/static/images/tv_turn_down.png') no-repeat;
          background-size: cover;
        }

        .topBtnM {
          width: 140px;
          height: 60px;
          display: flex;
          position: relative;
          background: url('/static/images/voice_normal_bg.png') no-repeat;
          background-size: cover;

          .voiceBtn {
            width: 50%;
            height: 100%;
            position: absolute;
          }

          .topBtnMLeft {
            left: 0;
            top: 0;

            &:active {
              background: url('/static/images/voice_dec__down_bg.png') no-repeat;
              background-size: cover;
              width: 100%;
              z-index: 10;
            }
          }

          .topBtnMRight {
            right: 0;
            top: 0;

            &:active {
              background: url('/static/images/voice_inc_down_bg.png') no-repeat;
              background-size: cover;
              width: 100%;
              z-index: 10;
            }
          }

          .voice_down {
            background: url('/static/images/voice_dec__down_bg.png') no-repeat;
            background-size: cover;
            width: 100%;
            z-index: 10;
          }

          .voice_up {
            background: url('/static/images/voice_inc_down_bg.png') no-repeat;
            background-size: cover;
            width: 100%;
            z-index: 10;
          }
        }

        .topBtnR {
          width: 50px;
          height: 50px;
          background: url('/static/images/mute_down_bg.png') no-repeat;
          background-size: 100% 100%;

          &:active {
            background: url('/static/images/mute_nomal_bg.png') no-repeat;
            background-size: cover;
          }
        }

        .muteOn {
          background: url('/static/images/mute_nomal_bg.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .top2 {
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 220px;
        margin-top: -170px;
        display: flex;
        justify-content: space-around;
        flex: 1;
        align-items: center;

        .top2_direction222 {
          background: url('/static/images/director_up.png') no-repeat !important;
          background-size: cover;
          display: flex;
          width: 200px;
          height: 200px;
          position: relative;
        }

        .top2_direction {
          display: flex;
          width: 200px;
          height: 200px;
          background: url('/static/images/director_normal.png') no-repeat;
          background-size: 100% 100%;
          position: relative;
        }

        .top2_btn {
          width: 60px;
          height: 60px;
          position: absolute;
        }

        .top2_up {
          width: 100%;
          height: 60px;
          left: 0;
          top: 0;

          &:active {
            background: url('/static/images/director_up.png') no-repeat;
            background-size: 200px 200px;
            z-index: 11;
            height: 200px;
          }
        }

        .top2_left {
          height: 100%;
          width: 60px;
          left: 0;
          top: 0;

          &:active {
            background: url('/static/images/director_left.png') no-repeat;
            background-size: 200px 200px;
            z-index: 11;
            width: 200px;
          }
        }

        .top2_middle {
          width: 60px;
          height: 60px;
          left: 70px;
          top: 70px;
          background: url('/static/images/director_ok.png') no-repeat;
          background-size: cover;
          z-index: 12;

          &:active {
            background: url('/static/images/director_ok_press.png') no-repeat;
            background-size: cover;
          }
        }

        .top2_right {
          height: 100%;
          width: 60px;
          right: 0;
          top: 0;

          &:active {
            background: url('/static/images/director_right.png') no-repeat;
            background-size: 200px 200px;
            z-index: 11;
            width: 200px;
          }
        }

        .top2_down {
          width: 100%;
          height: 60px;
          left: 0;
          bottom: 0;

          &:active {
            background: url('/static/images/director_down.png') no-repeat;
            background-size: 200px 200px;
            z-index: 11;
            height: 200px;
          }
        }

        .top2_up_hover {
          background: url('/static/images/director_up.png') no-repeat;
          background-size: 200px 200px;
          z-index: 10;
          height: 100px;
        }

        .top2_left_hover {
          background: url('/static/images/director_left.png') no-repeat;
          background-size: 200px 200px;
          z-index: 10;
          width: 100px;
        }

        .top2_middle_hover {
          background: url('/static/images/director_ok_press.png') no-repeat;
          background-size: 200px 200px;
          background-size: cover;
        }

        .top2_right_hover {
          background: url('/static/images/director_right.png') no-repeat;
          background-size: 200px 200px;
          z-index: 10;
          width: 100px;

        }

        .top2_down_hover {
          background: url('/static/images/director_down.png') no-repeat;
          background-size: 200px 200px;
          z-index: 10;
          height: 100px;
        }


      }

      .top3 {
        width: 100%;
        height: 60px;
        position: absolute;
        left: 0;
        bottom: 180px;
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        align-items: center;
        /*padding: 0 10px;*/

        .top3_left {
          background: url('/static/images/tv_back_up.png') no-repeat;
          width: 150px;
          height: 62px;
          background-size: cover;

          &:active {
            background: url('/static/images/tv_back_down.png') no-repeat;
            width: 150px;
            height: 62px;
            background-size: cover;
          }
        }

        .top3_left_hover {
          background: url('/static/images/tv_back_down.png') no-repeat;
          width: 145px;
          height: 62px;
          background-size: cover;
        }

        .top3_right {
          background: url('/static/images/tv_menu_icon.png') no-repeat;
          width: 150px;
          height: 62px;
          background-size: cover;

          &:active {
            background: url('/static/images/tv_menu_icon_down.png') no-repeat;
            width: 150px;
            height: 62px;
            background-size: cover;
          }
        }

        .top3_right_hover {
          background: url('/static/images/tv_menu_icon_down.png') no-repeat;
          width: 145px;
          height: 62px;
          background-size: cover;
        }
      }

      .top4 {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        max-height: 150px;
        border-top: 2px solid #000;

        .top4_middle {
          width: 1px;
          height: 70%;
          border-left: 2px solid #000;
          margin-top: 5%;
        }

        .top4_left_wrap {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          &:active .top4_left {
            width: 35px;
            height: 35px;
            background: url('/static/images/tv_home_down.png') no-repeat;
            background-size: cover;
          }
        }

        .top4_right_wrap {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          &:active .top4_right {
            width: 35px;
            height: 35px;
            background: url('/static/images/tv_menu_search_down.png') no-repeat;
            background-size: cover;
          }
        }

        .top4_left {
          width: 35px;
          height: 35px;
          background: url('/static/images/tv_home.png') no-repeat;
          background-size: cover;

          &:active {
            width: 35px;
            height: 35px;
            background: url('/static/images/tv_home_down.png') no-repeat;
            background-size: cover;
          }
        }

        .top4_left_hover {
          width: 35px;
          height: 35px;
          background: url('/static/images/tv_home_down.png') no-repeat;
          background-size: cover;
        }

        .top4_right {
          width: 35px;
          height: 35px;
          background: url('/static/images/tv_menu_search.png') no-repeat;
          background-size: cover;

          &:active {
            width: 35px;
            height: 35px;
            background: url('/static/images/tv_menu_search_down.png') no-repeat;
            background-size: cover;
          }
        }

        .top4_right_hover {
          width: 35px;
          height: 35px;
          background: url('/static/images/tv_menu_search_down.png') no-repeat;
          background-size: cover;
        }
      }
    }
  }

</style>
